import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import { ReactComponent as PriceIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as LocationIcon } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as StarIcon } from "feather-icons/dist/icons/star.svg";
import { ReactComponent as ChevronLeftIcon } from "feather-icons/dist/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "feather-icons/dist/icons/chevron-right.svg";
import { Button } from 'primereact/button';
import JobFormModal from "components/modals/JobFormModal";
import JobApplicationModal from "components/modals/JobApplicationModal";
import { deleteJob } from "api/jobs";
import DeleteJobModal from "components/modals/DeleteJobModal";
import Cookies from 'js-cookie';

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20`;

const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-between`;
const Heading = tw(SectionHeading)``;
const Controls = tw.div`flex items-center`;
const ControlButton = styled(PrimaryButtonBase)`
  ${tw`mt-2 sm:mt-0 first:ml-0 ml-6 rounded-full p-2`}
  svg {
    ${tw`w-6 h-6`}
  }
`;
const PrevButton = tw(ControlButton)``;
const NextButton = tw(ControlButton)``;

const CardSlider = styled(Slider)`
  ${tw`mt-16`}
  .slick-track { 
    ${tw`flex`}
  }
  .slick-slide {
    ${tw`h-auto flex justify-center mb-1`}
  }
`;
const Card = tw.div`h-full flex! flex-col sm:border max-w-sm sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;
const CardImage = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-56 sm:h-64 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`
]);

const TextInfo = tw.div`py-6 sm:px-10 sm:py-6`;
const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
const Title = tw.h5`text-2xl font-bold`;

const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-6 h-6 text-yellow-500 fill-current`}
  }
`;
const Rating = tw.span`ml-2 font-bold`;

const Description = tw.p`text-sm leading-loose mt-2 sm:mt-4`;

const SecondaryInfoContainer = tw.div`flex flex-col sm:flex-row mt-2 sm:mt-4`;
const IconWithText = tw.div`flex items-center mr-6 my-2 sm:my-0`;
const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
const Text = tw.div`ml-2 text-sm font-semibold text-gray-800`;

const PrimaryButton = tw(PrimaryButtonBase)`mt-auto sm:text-lg rounded-none w-full rounded sm:rounded-none sm:rounded-br-4xl py-3 sm:py-6`;
const CreateButton = tw(PrimaryButtonBase)`bg-pbsGreen-500 text-gray-100 hover:bg-pbsGreen-700`;

// Edit/Delete are shown side by side for logged-in users, so they share a row
// instead of each claiming full width the way the single-button variants used to.
const ActionButtonsRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: auto;
`;
const RowButton = styled(PrimaryButtonBase)`
  ${tw`sm:text-lg rounded-none rounded sm:rounded-none sm:rounded-br-4xl py-3 sm:py-6`}
  flex: 1;
`;
const EditRowButton = styled(RowButton)`
  ${tw`bg-pbsGreen-500 text-gray-100 hover:bg-pbsGreen-700`}
`;
const DeleteRowButton = styled(RowButton)`
  ${tw`bg-pbsOrange-500 text-gray-100 hover:bg-pbsOrange-700`}
`;

export default function JobsThreeColSlider ({jobs}) {
  // useState is used instead of useRef below because we want to re-render when sliderRef becomes available (not null)
  const [jobFormVisible, setJobFormVisible] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [jobVisible, setJobVisible] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [jobTitle, setJobTitle] = useState(null);
  const [sliderRef, setSliderRef] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const sliderSettings = {
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        }
      },

      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  };

  useEffect(() => {
    console.log(jobId);
    
  }, [jobId])

  useEffect(() => {
    console.log(jobs);

  }, [jobs])

  const handleCreateClick = () => {
    setEditingJob(null);
    setJobFormVisible(true);
  };

  const handleEditClick = (job) => {
    setEditingJob(job);
    setJobFormVisible(true);
  };

  const handleJobFormVisibility = (nextVisible) => {
    setJobFormVisible(nextVisible);
    if (!nextVisible) setEditingJob(null);
  };

  const removeJob = () => {
    deleteJob({jobId, jobTitle}).then(response => {
      if (response.success) {
        console.log('Job deleted successfully:', response);
        window.location.reload(); // Reload the page to reflect changes
        setJobVisible(false); // Optionally close the modal
      } else {
        console.error('Failed to delete job:', response.message);
      }
    }).catch(error => {
      console.error('Error deleting job:', error);
    });
    console.log("Delete job with ID:", jobId);
    // Call the deleteJob API function here with jobId
  };

  return (
    <Container>
      <Content>
        <HeadingWithControl>
          <Heading>Career Listing</Heading>
          <Controls>
            <PrevButton onClick={sliderRef?.slickPrev}><ChevronLeftIcon/></PrevButton>
            <NextButton onClick={sliderRef?.slickNext}><ChevronRightIcon/></NextButton>
          </Controls>
        </HeadingWithControl>
        { Cookies.get('id') && (
          <CreateButton onClick={handleCreateClick}>Create Job</CreateButton>
        )}
        <JobFormModal
          visible={jobFormVisible}
          setVisible={handleJobFormVisibility}
          job={editingJob}
          onSaved={() => window.location.reload()}
        />
        <DeleteJobModal visible={showDeleteModal} setVisible={setShowDeleteModal} onConfirm={removeJob}></DeleteJobModal>
        <JobApplicationModal jobId={jobId} jobTitle={jobTitle} visible={jobVisible} setVisible={setJobVisible}></JobApplicationModal>
        <CardSlider ref={setSliderRef} {...sliderSettings}>
          {jobs && jobs.length > 0 && jobs.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.image_url} />
              <TextInfo>
                <TitleReviewContainer>
                  <Title>{card.title}</Title>
                </TitleReviewContainer>
                <SecondaryInfoContainer>
                  <IconWithText>
                    <IconContainer>
                      <LocationIcon />
                    </IconContainer>
                    <Text>{card.parish}</Text>
                  </IconWithText>
                  <IconWithText>
                    {/* <IconContainer>
                      <PriceIcon />
                    </IconContainer>
                    <Text>{card.pay}</Text> */}
                  </IconWithText>
                </SecondaryInfoContainer>
                <Description>
                  <b>Requirements</b> <br />
                  {(() => {
                    const items = card.description.split(".").filter(item => item.trim() !== "");
                    return items.map((item, idx) => (
                      <span key={idx}>
                        - {item}
                        {idx < items.length - 1 && <br />}
                      </span>
                    ));
                  })()}
                </Description>
              </TextInfo>
              { !Cookies.get('id') ? (
                <PrimaryButton onClick={() => {setJobVisible(true); setJobId(card.id); setJobTitle(card.title);}}>Apply Now</PrimaryButton>
              ) : (
                <ActionButtonsRow>
                  <EditRowButton onClick={() => handleEditClick(card)}>Edit Job</EditRowButton>
                  <DeleteRowButton onClick={() => {setShowDeleteModal(true); setJobId(card.id); setJobTitle(card.title);}}>Delete Job</DeleteRowButton>
                </ActionButtonsRow>
              )}
            </Card>
          ))}
        </CardSlider>
      </Content>
    </Container>
  );
};